import { Api } from '@axiom/ui';
import type { User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class UserApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readUser() {
    return super.read<{ data: User }>({
      endpoint: `/user/me`,
      method: 'GET',
    });
  }
}

export const UserApi = new UserApiClass();
